import React, { useState } from 'react';

const App = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchData = async () => {
    setLoading(true);
    setError('');
    setData([]);

    try {
      const response = await fetch('https://traininingsite1.shigtest.com/api/kiki');
      //const response = await fetch('/api/kiki');
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      const json = await response.json();
      setData(json);
    } catch (err) {
      setError(err.message);
    }

    setLoading(false);
  };

  return (
    <div style={{ padding: '2rem', fontFamily: 'Arial, sans-serif' }}>
      <h1>📋 Device List Demo CICD 1906</h1>
      <button onClick={fetchData} disabled={loading}>
        {loading ? 'Loading......' : 'Fetch Data'}
      </button>

      {error && <p style={{ color: 'red', marginTop: '1rem' }}>❌ Error: {error}</p>}

      {data.length > 0 && (
        <table
          border="1"
          cellPadding="10"
          style={{ marginTop: '1.5rem', borderCollapse: 'collapse', width: '100%' }}
        >
          <thead style={{ backgroundColor: '#f0f0f0' }}>
            <tr>
              <th>Name</th>
              <th>Tag No</th>
              <th>Vendors</th>
              <th>Fluid Name</th>
              <th>Fluid Temp (°C)</th>
            </tr>
          </thead>
          <tbody>
            {data.map((device, index) => (
              <tr key={index}>
                <td>{device.name}</td>
                <td>{device.tagNo}</td>
                <td>{device.vendors}</td>
                <td>{device.fluidName}</td>
                <td>{device.fluidTemp}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default App;
